// src/utils/storage.js

function safeParse(value) {
  if (value == null) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function createStore(driver, options = {}) {
  const prefix = options.prefix || ""; // 预留：以后加分区

  const getKey = (k) => (prefix ? `${prefix}:${k}` : k);

  return {
    /**
     * set(key, value, expireMs?)
     * expireMs：毫秒，不传 = 永不过期
     */
    set(key, value, expireMs) {
      try {
        const data =
          typeof expireMs === "number"
            ? { v: value, e: Date.now() + expireMs }
            : { v: value };

        driver.setItem(getKey(key), JSON.stringify(data));
        return true;
      } catch {
        return false;
      }
    },

    /**
     * get(key, fallback?)
     */
    get(key, fallback = null) {
      try {
        const raw = driver.getItem(getKey(key));
        if (!raw) return fallback;

        const data = safeParse(raw);
        if (!data || !("v" in data)) return fallback;

        if (typeof data.e === "number" && Date.now() > data.e) {
          driver.removeItem(getKey(key));
          return fallback;
        }

        return data.v;
      } catch {
        return fallback;
      }
    },

    /**
     * 是否存在且未过期
     */
    has(key) {
      try {
        const raw = driver.getItem(getKey(key));
        if (!raw) return false;

        const data = safeParse(raw);
        if (!data || !("v" in data)) return false;

        if (typeof data.e === "number" && Date.now() > data.e) {
          driver.removeItem(getKey(key));
          return false;
        }

        return true;
      } catch {
        return false;
      }
    },

    /**
     * 删除
     */
    remove(key) {
      try {
        driver.removeItem(getKey(key));
      } catch {}
    },
  };
}

// 现在：不分区
export const storageLocal = createStore(window.localStorage);
export const sessionLocal = createStore(window.sessionStorage);

/**
 * 将来：需要分区时，只改这一行
 * export const storage = createStore(window.localStorage, { prefix: "app" });
 * export const session = createStore(window.sessionStorage, { prefix: "app" });
 */
